export enum InsightPriority {
  NiceToHave = 'nice-to-have',
  Important = 'important',
  MustHave = 'must-have',
  NoPriority = 'no-priority',
}

export enum InsightCreatedVia {
  comment = 'comment',
  idea = 'idea',
  post = 'post',
  vote = 'vote',
}
